/* eslint no-console:0 */
import "@webcomponents/custom-elements"
import "abortcontroller-polyfill/dist/polyfill-patch-fetch"
import { navigator } from "@hotwired/turbo"
import { loadGAScript, handleGAOptedOutEvent } from "../utils/google_analytics"
import { deferLoadGTMScript } from "../utils/google_tag_manager"
import { disableButtonHandler } from "../utils/turbolinks"
import "controllers"
import { initializeAffiliateRecording, handleAffiliateOptedOutEvent } from "../utils/affiliate_recording"
import { handleExperimentOptedOutEvent } from "../utils/experiments_opt_out"
import ga from "../utils/ga"

loadGAScript()
handleGAOptedOutEvent()
deferLoadGTMScript()
disableButtonHandler(document)
initializeAffiliateRecording(window.location, document.referrer)
handleAffiliateOptedOutEvent()
handleExperimentOptedOutEvent()

// Trigger progress bar to display on form submission.
// This doesn't happen automatically for form submissions.
document.addEventListener("turbo:submit-start", () => {
  navigator.delegate.adapter.showProgressBar()
})

document.addEventListener("turbo:submit-end", () => {
  navigator.delegate.adapter.hideProgressBar()
})

document.addEventListener("turbo:click", (event) => {
  document.body.classList.add("loading")
  if (event.detail.url.endsWith("#content")) {
    const content = document.getElementById("content")
    if (content) {
      content.scrollIntoView()
    }
  }
})

document.addEventListener("turbo:before-visit", () => {
  document.body.classList.add("loading")
})

// don't send ga events during turbo load because they won't be tied to the correct URL
document.addEventListener("turbo:visit", () => {
  ga.queue.pause()
})
// you may continue
document.addEventListener("turbo:load", () => {
  ga.queue.unpause()
})
// in case there's anything left in the queue
window.addEventListener("beforeunload", () => {
  ga.queue.process()
})

document.addEventListener("turbo:render", () => {
  document.body.classList.remove("loading")
})
